import { useRef, useState, useEffect } from "react";

// Custom hook for auto-adjusting font size
export const useAutoAdjustFontSize = <T extends HTMLElement>(initialSize = 16) => {
  const ref = useRef<T>(null);
  const [fontSize, setFontSize] = useState(initialSize);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const adjustFontSize = () => {
    if (ref.current) {
      if (
        ref.current.scrollHeight > ref.current.clientHeight ||
        ref.current.scrollWidth > ref.current.clientWidth
      ) {
        setFontSize((current) => current - 1);
      } else {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      }
    }
  };

  useEffect(() => {
    intervalRef.current = setInterval(adjustFontSize, 50);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const reset = () => {
    setFontSize(initialSize);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(adjustFontSize, 50);
  };

  return { ref, fontSize, reset };
};